import styled from 'styled-components';
import { layout } from '../../../package.json';

interface ContainerProps {
  bJustifyContentCenter?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: ${props => props.bJustifyContentCenter ? 'center' : 'flex-start'};
  align-items: center;
  flex-direction: column;

  background-color: #f4f4f4;
  border-radius: 8px;
  min-height: 400px;
  bottom: 20px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin-bottom: 2rem;

  span {
    font-size: 1.5rem;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-bottom: 2rem;

  span {
    font-size: 1.5rem;
  }

  @media (max-width: ${layout.mobile}) {
    flex-direction: column;
    gap: 5px;
    margin-bottom: 0px;
  }
`;

export const ContainerTitle = styled.div`
  span {
    top: 10px;
    color: #999999;
    font-size: 0.87rem;
    font-weight: 800;
  }
`;


export const ContainerPayments = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;
`;

export const ContainerPayment = styled.div`
  display: flex;
  justify-content: flex-start;

  margin-top: 15px;
  width: 100%;

  border-radius: 8px;
`;

export const ContainerPaymentItem = styled.div`
  grid-gap: 16px;
  width: 100%;
`;

export const ContainerPaymentMethods = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 16px;

  width: 50%;
`;

export const ItemPayment = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 150px;
  height: 40px;

  cursor: pointer;

  border: 1px solid var(--primary);
  padding: 10px;
  border-radius: 20px;
  margin-right: 10px;
  transition:all 0.6s ease;

  text-align: center;
  span {
      color: var(--primary);
      font-size: 14px;
    }

  :hover{
    background-color: var(--primary);

    span {
      color: #FFF;
      font-size: 14px;
    }
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;

export const AddButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 190px;
  height: 50px;
  cursor: pointer;
  border: 1px solid var(--primary);
  border-radius: 6px;
  background-color: #FFF;
  transition:all 0.6s ease;
  margin-left: 8px;

  span {
    font-size: 18px;
  }
  svg {
    color: var(--btn-finish);
    margin-right: 5px;
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }
`;

interface PayDeliveryButtonProps {
  checked?: boolean;
}

export const PayDeliveryButton = styled.div<PayDeliveryButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 190px;
  height: 50px;
  cursor: pointer;
  border: ${props => props.checked ? '2px' : '1px'} solid ${props => props.checked ? 'var(--green)' : 'var(--primary)'};
  border-radius: 6px;
  background-color: #FFF;
  transition:all 0.6s ease;
  margin-left: 8px;

  span {
    font-size: 18px;
  }
  svg {
    color: var(--btn-finish);
    margin-right: 5px;
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }
`;

export const ContainerMethodsList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const ContainerMethodNoData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  span {
    font-size: 22px;
    margin-top: 16px;
    color: var(--primary);
  }

`;

export const ContainerMethodData = styled.div`
 display: flex;
 width: 100%;
 div {
   display: flex;
   align-items: center;
   margin-left: 0.25rem;
 }

  @media (max-width: ${layout.desktop}) {
    div > div {
     flex-direction: column;
     align-items: flex-start;
    }
  }
`;

export const ContainerMethod = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 0 2%;
  height: 60px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  border-radius: 10px;

  transition:all 0.6s ease;

  background-color: #FFF;

  span {
    color: var(--primary);
  }
`;

export const CardButton = styled.div`
  cursor: pointer;
  :hover{
      svg {
      color: var(--btn-finish);
    }

  }
`;

export const CardBrand = styled.div`
  margin-right: 10px;
`;

export const CardNumber = styled.div`
margin-right: 10px;
`;

export const CardName = styled.div`
margin-right: 10px;

`;
